module.exports = __webpack_public_path__ + "static/media/ubs-active.8797a5d7.svg";